import { render, staticRenderFns } from "./SivForm.vue?vue&type=template&id=1bebc2d2&scoped=true&"
import script from "./SivForm.vue?vue&type=script&lang=ts&"
export * from "./SivForm.vue?vue&type=script&lang=ts&"
import style0 from "./SivForm.vue?vue&type=style&index=0&id=1bebc2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bebc2d2",
  null
  
)

export default component.exports